import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { useSettings } from '../context/SettingsContext';
import { formatCurrency } from '../utils/currency';
import { LoadingState } from '../components/Loading';
import { FaCheckCircle, FaShoppingBag, FaArrowRight } from 'react-icons/fa';

const OrderConfirmation = () => {
  const { id } = useParams();
  const { settings } = useSettings();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOrder();
  }, [id]);

  const loadOrder = async () => {
    try {
      const res = await axios.get(`/api/orders/${id}`);
      setOrder(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="page"><LoadingState /></div>;
  if (!order) return (
    <div className="page">
      <div className="container empty-state">
        <h3>Order not found</h3>
        <Link to="/products" className="btn btn-primary">Back to shop</Link>
      </div>
    </div>
  );

  return (
    <div className="page">
      <div className="container" style={{ maxWidth: 720 }}>
        <div className="card" style={{ textAlign: 'center', padding: '48px 32px' }}>
          <div style={{
            width: 80, height: 80, borderRadius: '50%',
            background: 'var(--success-50)', color: 'var(--success-600)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 40, marginBottom: 20,
          }}>
            <FaCheckCircle />
          </div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 32, marginBottom: 8 }}>
            Thank you for your order!
          </h1>
          <p style={{ color: 'var(--gray-500)', marginBottom: 32 }}>
            Your order has been received and is being processed.
            We'll send you a confirmation email shortly.
          </p>

          <div style={{
            background: 'var(--gray-50)', padding: 20, borderRadius: 'var(--radius)',
            display: 'flex', flexDirection: 'column', gap: 8, textAlign: 'left',
            marginBottom: 32,
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ color: 'var(--gray-500)' }}>Order number</span>
              <strong>{order.orderNumber}</strong>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ color: 'var(--gray-500)' }}>Items</span>
              <strong>{order.items.length}</strong>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ color: 'var(--gray-500)' }}>Total</span>
              <strong>{formatCurrency(order.total, settings?.currency)}</strong>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ color: 'var(--gray-500)' }}>Payment method</span>
              <strong style={{ textTransform: 'capitalize' }}>{order.paymentMethod}</strong>
            </div>
          </div>

          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to={`/my-orders/${order._id}`} className="btn btn-primary">
              <FaShoppingBag /> View order details
            </Link>
            <Link to="/products" className="btn btn-secondary">
              Continue shopping <FaArrowRight />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;
